import script from "./DsAttendanceSheetMirror.vue?vue&type=script&setup=true&lang=ts"
export * from "./DsAttendanceSheetMirror.vue?vue&type=script&setup=true&lang=ts"

import "./DsAttendanceSheetMirror.vue?vue&type=style&index=0&id=266b0538&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-266b0538"]])

export default __exports__